import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  termsConditionsDetails,
  termsConditionsList,
} from "../../api/termsConditions";

const initialState = {
  list: [],
  total: 0,
  detail: null,
};

export const termsConditionsSlice = createSlice({
  name: "termsConditions",
  initialState,
  reducers: {
    list: (state, action) => {
      state.list = action.payload;
    },
    total: (state, action) => {
      state.total = action.payload;
    },
    detail: (state, action) => {
      state.detail = action.payload;
    },
  },
});

export const FetchTermsConditions = createAsyncThunk(
  "FetchTermsConditions",
  async (obj, { dispatch }) => {
    try {
      const response = await termsConditionsList(obj);
      if (response?.code === 1) {
        dispatch(list(response?.data?.list));
        dispatch(total(response?.data?.count));
      }
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

export const FetchTermsConditionsDetail = createAsyncThunk(
  "FetchTermsConditionsDetail",
  async (obj, { dispatch }) => {
    try {
      const response = await termsConditionsDetails(obj);
      if (response?.code === 1) {
        dispatch(detail(response?.data?.details));
      }
      return response;
    } catch (error) {
      toast.error(error.message, { autoClose: false, closeButton: true });
    }
  }
);

export const { list, total, detail } = termsConditionsSlice.actions;

export default termsConditionsSlice.reducer;
